var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobileMode)?_c('mobileFooter'):_c('pcHFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }